import Agreement from './agreement';
import Base from './base/ContractInputBase';
import DistributionSection from './distributionSection/ContractInputDistributionSection';
import Main from './main/ContractInputMain';
import Section from './section/ContractInputSection';
import Wrapper from './wrapper/ContractInputWrapper';

export default {
  Base,
  Wrapper,
  Section,
  Main,
  Agreement,
  DistributionSection,
};
